module.exports = __webpack_public_path__ + "img/close-icon.85afb61f.svg";